import { Component, Output, Input, EventEmitter } from '@angular/core';
import { CompanySetting } from '@models/settings/company-setting.model';
import { PerformanceNotificationsDisplayOptions } from '@app/types/translatables/performance-notifications-display.options';

@Component({
    selector: 'app-company-setting',
    templateUrl: './company-setting.template.html',
    styleUrls: ['./company-setting.style.scss'],
})
export class CompanySettingComponent {
    @Input() companySetting: CompanySetting;
    @Output() toggled = new EventEmitter<CompanySetting>();

    performanceNotificationsDisplayOptions = PerformanceNotificationsDisplayOptions;

    onToggle(): void {
        this.toggled.emit(this.companySetting);
    }
}
